import { Trans, useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import React from "react";

import { ChoosingModal } from "../../../components/ui-kit/choosing-modal/choosing-modal";
import { DataTable } from "../../../components/ui-kit/tables/data-table";
import { SelectionMode } from "../../../models/data-model";
import { uniqueValueOptions } from "../../../utils/filter-presets";
import { Users, UsersItem } from "../users/users";

export const UsersModal = observer(function UsersModal(props: {
  model: Users;
  mode: SelectionMode;
  preselected?: string[];
  filter?: Record<string, any[]>;
  title: React.ReactNode;
  onConfirm: (params: { selected: any[] }) => void;
  onClose: () => void;
}) {
  const { t } = useLingui();
  const initialFilter = props.filter ?? props.model.defaultFilter;

  return (
    <ChoosingModal
      model={props.model}
      onClose={props.onClose}
      onConfirm={props.onConfirm}
      title={props.title}
      fillHeight
      table={
        <DataTable
          rowsPerPage={10}
          model={props.model}
          itemKeyField="uuid"
          isLoading={props.model.loading}
          fillHeight
          canSelect={props.mode}
          preselected={props.preselected}
          initialColumnFilters={
            initialFilter
              ? Object.entries(initialFilter).map(([id, value]) => ({
                  id,
                  value,
                }))
              : undefined
          }
          columns={[
            {
              header: <Trans>Username</Trans>,
              attr: "username",
              type: "string",
              sort: true,
              initSort: "asc",
              className: "font-bold",
              align: "left",
              filter: {
                kind: "text",
                group: t`Users`,
                placeholder: t`Search…`,
              },
            },
            {
              header: <Trans>Role</Trans>,
              attr: "role",
              type: "string",
              filter: {
                kind: "multi",
                group: t`Users`,
                options: uniqueValueOptions<UsersItem>("role"),
              },
            },
            {
              header: <Trans># of managed patients</Trans>,
              width: 30,
              cell: ({ item }) => item.visible_patients?.length ?? 0,
            },
            {
              header: <Trans># of monitored patients</Trans>,
              width: 30,
              cell: ({ item }) =>
                item.access_policy?.visible_patients?.length ?? 0,
            },
          ]}
        />
      }
    />
  );
});
